/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Routes } from "@angular/router";

import { AuthLayoutComponent } from "./components/auth.component";
import { LoginComponent } from "./components/login/vta.login.component";
import { RegisterComponent } from "./components/register/vta.register.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { RequestPasswordComponent } from "./components/request-password/vta.request-password.component";
import { ResetPasswordComponent } from "./components/reset-password/vta.reset-password.component";
import { VerifyUserComponent } from "./components/verify-user/vta.verify-user.component";
import { ApproveRequestComponent } from "./components/approve-request/vta.approve-request.component";
import { VerifyEmailComponent } from "./components/verify-email/vta.verify-email.component";

export const routes: Routes = [
  {
    path: "/",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        component: LoginComponent,
      },
      {
        path: "login",
        component: LoginComponent,
      },
      {
        path: "register",
        component: RegisterComponent,
      },
      {
        path: "logout",
        component: LogoutComponent,
      },
      {
        path: "request-password",
        component: RequestPasswordComponent,
      },
      {
        path: "resetpassword",
        component: ResetPasswordComponent,
      },
      {
        path: "verify",
        component: VerifyUserComponent,
      },
      {
        path: "verifyEmail",
        component: VerifyEmailComponent,
      },
      {
        path: "approve",
        component: ApproveRequestComponent,
      },
      {
        path: "view",
        component: ApproveRequestComponent,
      },
    ],
  },
];
